import React from "react";

import { Box, Hidden, IconButton, Link, Typography } from "@mui/material";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

const sectionStyle = {
  display: "flex",
  flexDirection: "row",
  marginBottom: 1,
  textAlign: "center",
};

const buttonStyle = {
  backgroundColor: "#1975b9",
  "&:hover": {
    backgroundColor: "#1975b9",
  },
  marginLeft: 2,
  marginRight: 2,
};

const ExternalLink = ({ children, ...props }) => (
  <Link
    color="primary.contrastText"
    underline="hover"
    variant="body2"
    {...props}
  >
    {children}
  </Link>
);

const Footer = ({ sx, ...props }) => (
  <footer>
    <Box
      sx={{
        // Hack: theme => style doesn't work: Failed prop type: Invalid prop `sx` supplied to `ForwardRef(Box)`
        // theme.palette.primary.main
        backgroundColor: "#5b4983",
        backgroundOrigin: "border-box",
        paddingBottom: 4,
        paddingTop: 3,
        width: "100%",
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          justifyContent: "center",
          mx: 1,
        }}
      >
        <Box sx={sectionStyle}>
          <ExternalLink
            href="https://www.facebook.com/flyingmilktea/"
            target="_blank"
          >
            <IconButton sx={buttonStyle}>
              <FacebookIcon htmlColor="white" fontSize="small" />
            </IconButton>
          </ExternalLink>

          <ExternalLink
            href="https://www.instagram.com/flyingmilktea_/"
            target="_blank"
          >
            <IconButton sx={buttonStyle}>
              <InstagramIcon htmlColor="white" fontSize="small" />
            </IconButton>
          </ExternalLink>

          <ExternalLink
            href="https://twitter.com/flyingmilktea"
            target="_blank"
          >
            <IconButton sx={buttonStyle}>
              <TwitterIcon htmlColor="white" fontSize="small" />
            </IconButton>
          </ExternalLink>
        </Box>

        <Box sx={{ m: 1 }} />
        <Box sx={sectionStyle}>
          <ExternalLink href="https://www.flyingmilktea.com/about/">
            關於我們
          </ExternalLink>
          <Typography variant="body2" color="primary.contrastText">
            &nbsp;｜&nbsp;
          </Typography>
          <ExternalLink href="https://www.flyingmilktea.com/qa/">
            常見問題
          </ExternalLink>
        </Box>

        <Box sx={sectionStyle}>
          <ExternalLink href="https://www.flyingmilktea.com/terms/">
            服務條款
          </ExternalLink>
          <Typography variant="body2" color="primary.contrastText">
            &nbsp;｜&nbsp;
          </Typography>
          <ExternalLink href="https://www.flyingmilktea.com/privacy/">
            隱私權聲明
          </ExternalLink>
          <Hidden smDown>
            <Typography variant="body2" color="primary.contrastText">
              &nbsp;｜&nbsp;
            </Typography>
          </Hidden>
          <Hidden smDown>
            <ExternalLink href="https://www.flyingmilktea.com/terms-of-use-charged-service/">
              收費服務及虛擬貨幣（珍珠）使用條款
            </ExternalLink>
          </Hidden>
        </Box>

        <Hidden smUp>
          <Box sx={sectionStyle}>
            <ExternalLink href="https://www.flyingmilktea.com/terms-of-use-charged-service/">
              收費服務及虛擬貨幣（珍珠）使用條款
            </ExternalLink>
          </Box>
        </Hidden>

        <Box m={1} />
        <Box sx={sectionStyle} prefetch={false}>
          <ExternalLink href="https://www.flyingmilktea.com" variant="caption">
            Copyright © 2019-2021 Flying Milk Tea. All rights reserved.
          </ExternalLink>
        </Box>
      </Box>
    </Box>
  </footer>
);
export default Footer;
